module.exports = __webpack_public_path__ + "img/dbanner.165d7f9d.png";